<div class="flex--column" style="padding: 15px">
  <agr-summary-card
    [title]="'sustainability.farm-resources' | translate"
    [canExpand]="false"
    [actions]="summaryCardActions"
    [isExpanded]="true"
    class="spacing--margin-bottom"
  >
    <ng-container customActions>
      <button mat-flat-button color="primary" (click)="openResourceSlideIn()">
        <mat-icon>add</mat-icon>{{ 'sustainability.add-farm-resources' | translate }}
      </button>
    </ng-container>

    <agr-table-v2 matSort [dataSource]="farmResourcesDataSource" [withSelection]="false">
      <ng-container *agrTableTopBar>
        <!-- Intentionally empty to remove the top bar -->
      </ng-container>

      <ng-container *agrTableFiltersWrapper>
        <!-- Intentionally empty to remove the clear filters button -->
      </ng-container>

      <ng-container matColumnDef="year">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.year' | translate }}
        </th>
        <td mat-cell class="text--bold" *matCellDef="let row; let i = index">
          {{ row.year }}
        </td>
      </ng-container>

      <ng-container matColumnDef="water">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.water' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.water | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="electricity">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.electricity' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.electricity | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="electricityPhotovoltaic">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.electricity-photovoltaic' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.electricityPhotovoltaic | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="electricityWind">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.electricity-wind' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.electricityWind | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="naturalGas">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.natural-gas' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.naturalGas | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="diesel">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.diesel' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.diesel | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="gasoline">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.gasoline' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.gasoline | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="propaneLpg">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.propane-lpg' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.propaneLpg | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="coal">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.coal' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          {{ row.coal | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'actions' | translate }}
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="this.openResourceSlideIn(row); $event.stopPropagation()">
              <mat-icon>edit</mat-icon>
              <span>{{ 'edit' | translate }}</span>
            </button>
            <button mat-menu-item (click)="this.deleteResource(row); $event.stopPropagation()">
              <mat-icon>delete</mat-icon>
              <span>{{ 'delete' | translate }}</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="farmResourcesColumns"></tr>
      <tr mat-row *matRowDef="let _; columns: farmResourcesColumns"></tr>
    </agr-table-v2>
  </agr-summary-card>

  <agr-summary-card
    *ngIf="(farmResourcesFlockDataSource.flockResources$ | async)?.length > 0"
    [title]="'sustainability.flock-resources' | translate"
    [canExpand]="false"
    [isExpanded]="true"
    class="spacing--margin-top"
  >
    <agr-table-v2
      matSort
      [dataSource]="farmResourcesFlockDataSource"
      [withStickyHeaders]="false"
      [withStickyColumns]="true"
      data-test="variety-property-table"
    >
      <ng-container *agrTableTopBar>
        <!-- Intentionally empty to remove the top bar -->
      </ng-container>

      <ng-container *agrTableFiltersWrapper>
        <!-- Intentionally empty to remove the clear filters button -->
      </ng-container>

      <ng-container matColumnDef="flockName" sticky>
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'flock-overview.flock' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.flockName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="flockStartDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.flock-start-date' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          <span>
            {{ item.flockStartDate | agrDate: 'dd-MM-yyyy' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="flockEndDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.flock-end-date' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          <span>
            {{ item.flockEndDate | agrDate: 'dd-MM-yyyy' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="water">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.water' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.water | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="electricity">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.electricity' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.electricity | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="electricityPhotovoltaic">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.electricity-photovoltaic' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.electricityPhotovoltaic | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="electricityWind">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.electricity-wind' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.electricityWind | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="naturalGas">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.natural-gas' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.naturalGas | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="diesel">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.diesel' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.diesel | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="gasoline">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.gasoline' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.gasoline | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="propaneLpg">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.propane-lpg' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.propaneLpg | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="coal">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.coal' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.coal | agrNumber: '1.0-0' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          {{ 'sustainability.resource.status' | translate }}
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.status }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let _; columns: displayedColumns"
        data-test="variety-property-row"
      ></tr>
    </agr-table-v2>
  </agr-summary-card>
</div>

<agr-notification-empty
  [isEmpty]="false"
  [emptyTitle]="'flock-overview.no-flocks.title' | translate"
  emptyImage="assets/images/arrival.jpg"
>
</agr-notification-empty>
